<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="form-group xrx-summarization portal-wrapper">
  @if (serviceIndex === 0) {
    <!--single workflow or first service in combo workflow-->
    <div [ngClass]="{ 'service-params': !isAutomated }">
      <div class="property-select">
        <xrx-select
          [label]="'SDE_INPUT_LANGUAGE'"
          [list]="list"
          [(selectedItem)]="languageOption"
          [localize]="'key'"
          [property]="'key'"
          [orderby]="'key'"
          (change)="onLanguageSelected()"
          [isInputOnly]="true">
        </xrx-select>
      </div>
    </div>
  } @else {
    <!--combo workflow preceded by translate or summarize with language setting -->
    <span class="mb-0" [xdaTranslate]="'SDE_INPUT_LANGUAGE'"></span>
    <div
      class="only-option"
      [xdaTranslate]="'SDE_FMTSTR_SELECTED_PREVIOUS'"
      [formatValues]="languageOption.key"></div>
  }

  <div [ngClass]="{ 'service-params': !isAutomated }" class="mt-2">
    <div class="property-select">
      <span class="label" [xdaTranslate]="'SDE_SUMMARIZATION_LENGTH'"></span>
      <button class="help nul-utility-btn" (click)="showHelp($event)">
        <i class="nul-button-glyph xgl-help"></i>
      </button>
      <xrx-select
        [list]="summarizationLength.options"
        [(selectedItem)]="summarizationLength.selectedValue"
        [localize]="'key'"
        [property]="'value'"
        (change)="onSummarizationLengthSelected()"
        [isInputOnly]="true">
      </xrx-select>
    </div>
  </div>
</div>
